import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./nuevo.css";

function Nuevo() {
  //Hooks
  const[partida, setPartida] = useState("");
  const [empleado, setEmpleado] = useState("");
  const [registro, setRegistro] = useState(new Date());
  const [inventario, setInventario] = useState("");
  const [serie, setSerie] = useState("");
  const [modelo, setModelo] = useState("");
  const [marca, setMarca] = useState("");
  const [tipo, setTipo] = useState("");
  const [software, setSoftware] = useState("");
  const [observaciones, setObservaciones] = useState("");

  const formattedDate = registro.toLocaleDateString();


  function agregarRegistro() {
    var registros = {
      partida,
      empleado,
      registro,
      inventario,
      serie,
      modelo,
      marca,
      tipo,
      software,
      observaciones,
    };
    console.log(registros);
    axios
      .post("http://localhost:5000/api/Inventario/", registros)
      .then((res) => {
        alert(res.registros);
      });
  }

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="mt-5">
            <h3 className="title">Inventario</h3>
            <hr className="hr-gob" />
          </div>
        </div>

        <form onSubmit={agregarRegistro}>
          <div className="row">
          <div className="col-md-4">
            <label for="validationServerUsername" className="form-label">
              Partida Presupuestal
            </label>
            <div className="input-group has-validation">
              <input
                type="text"
                className="form-control is-invalid"
                id="validationServerUsername"
                aria-describedby="inputGroupPrepend3 validationServerUsernameFeedback"
                value={partida}
                onChange={(e) => {
                  setPartida(e.target.value);
                }}
                required
              />
              <div
                id="validationServerUsernameFeedback"
                className="invalid-feedback"
              >
                Por favor escriba su partida presupuestal.
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <label for="validationServerUsername" className="form-label">
              Número de empleado
            </label>
            <div className="input-group has-validation">
              <span className="input-group-text" id="inputGroupPrepend3">
                N°
              </span>
              <input
                type="text"
                className="form-control is-invalid"
                id="validationServerUsername"
                aria-describedby="inputGroupPrepend3 validationServerUsernameFeedback"
                value={empleado}
                onChange={(e) => {
                  setEmpleado(e.target.value);
                }}
                required
              />
              <div
                id="validationServerUsernameFeedback"
                className="invalid-feedback"
              >
                Por favor escriba su número de empleado.
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div class="form-group">
              <label for="validationServerUsername" className="form-label">
                Fecha de registro
              </label>
              <div class="input-group date" id="datetimepicker1">
                <input type="date" class="form-control" 
                value={formattedDate}
                onChange={(e) => {
                  setRegistro(e.target.value);
                }}
                required />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <label for="validationServer01" className="form-label">
              Número de inventario
            </label>
            <input
              type="text"
              className="form-control is-valid"
              id="validationServer01"
              value={inventario}
                onChange={(e) => {
                  setInventario(e.target.value);
                }}
              required
            />
            <div className="valid-feedback">Looks good!</div>
          </div>
          <div className="col-md-4">
            <label for="validationServer02" className="form-label">
              Número de serie
            </label>
            <input
              type="text"
              className="form-control is-valid"
              id="validationServer02"
              value={serie}      
                    onChange={(e) => {setSerie(e.target.value)}}
              required
            />
            <div className="valid-feedback">Looks good!</div>
          </div>
          <div className="col-md-4">
            <label for="validationServer02" className="form-label">
              Modelo
            </label>
            <input
              type="text"
              className="form-control is-valid"
              id="validationServer02"
              value={modelo}      
                    onChange={(e) => {setModelo(e.target.value)}}
              required
            />
            <div className="valid-feedback">Looks good!</div>
          </div>

          <div className="col-md-6">
            <label for="validationServer03" className="form-label">
              Marca
            </label>
            <input
              type="text"
              className="form-control is-invalid"
              id="validationServer03"
              aria-describedby="validationServer03Feedback"
              value={marca}      
                    onChange={(e) => {setMarca(e.target.value)}}
              required
            />
            <div id="validationServer03Feedback" className="invalid-feedback">
              Por favor escribe la marca del equipo.
            </div>
          </div>
          <div className="col-md-3">
            <label for="validationServer04" className="form-label">
              Tipo
            </label>
            <select
              className="form-select is-invalid"
              id="validationServer04"
              aria-describedby="validationServer04Feedback"
              required
              value={tipo}      
                    onChange={(e) => {setTipo(e.target.value)}}
            >
              <option selected disabled value="">
                Elige una opción...
              </option>
              <option value="Computadora de Escritorio" >Computadora de Escritorio</option>
              <option value="Laptop">Laptop</option>
              <option value="Impresora" >Impresora</option>              
            </select>
            <div id="validationServer04Feedback" className="invalid-feedback">
              Por favor elige una opción
            </div>
          </div>
          <div className="col-md-3">
            <label for="validationServer04" className="form-label">
              Software
            </label>
            <select
              className="form-select is-invalid"
              id="validationServer04"
              aria-describedby="validationServer04Feedback"
              required
              value={software}      
                    onChange={(e) => {setSoftware(e.target.value)}}
            >
              <option selected disabled value="">
                Elige una opción...
              </option>
              <option value="Windows 7" >Windows 7</option>
              <option value="Windows 8">Windows 8</option>
              <option value="Windows 10">Windows 10</option>
              <option value="Windows 11">Windows 11</option>
              <option value="No aplica">No Aplica</option>              
            </select>
            <div id="validationServer04Feedback" className="invalid-feedback">
              Por favor elige el software que tiene el equipo.
            </div>
          </div>

          <div className="col-12">
            <div className="mb-3">
              <label for="validationTextarea" className="form-label">
                Observaciones
              </label>
              <textarea
                className="form-control is-invalid"
                id="validationTextarea"
                placeholder="Required example textarea"
                value={observaciones}      
                    onChange={(e) => {setObservaciones(e.target.value)}}
                required
              ></textarea>
              <div className="invalid-feedback">
                Por favor escriba alguna observación del equipo.
              </div>
            </div>
          </div>
          <div className="col-12">
            <button className="btn btn-primary" type="submit">
              Registrar
            </button>
          </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default Nuevo
